<template>
  <div class='table_card'>
    <el-dialog :title='dialogTitle' :visible.sync='showDialogVisible' width='56%' :before-close='dialogClose'>
      <el-form ref='dialogfrom' :model='addForm' label-width='172px' size='mini'>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label='姓名:' prop="id">
              <el-select v-model="addForm.id" filterable remote style="width: 100%" placeholder="请输入关键词"
                :remote-method="remoteMethod" @change="handleSelect" @click.native="clearForm" :loading="loading">
                <el-option v-for="item in options" :key="item.id" :label="item.customerName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label='身份证号:' prop="idCard">
              <el-input disabled v-model="addForm.idCard" size="medium" placeholder="根据姓名获取"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label='性别:' prop="gender">
                <el-select
                disabled
                v-model="addForm.gender"
                placeholder="根据姓名获取"
                size="medium"
                style="width: 100%"
              >
              <el-option label="男" value="0"></el-option>
              <el-option label="女" value="1"></el-option>
            </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label='出生日期:' prop="birthday">
              <el-input disabled v-model="addForm.birthday" size="medium" placeholder="根据姓名获取"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label='手机号码:' prop="phone">
              <el-input disabled v-model="addForm.phone" size="medium" placeholder="根据姓名获取"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label='年龄:' prop="age">
              <el-input disabled v-model="addForm.age" size="medium" placeholder="根据姓名获取"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class='boontbtn'>
        <el-button @click="locationSend" type="primary">确定 </el-button>
        <el-button type='info' size='small' @click='dialogClose'>取消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  props: ['showDialogVisible'],
  data() {
    return {
      dialogTitle: '新增',
      addForm: {},
      options: [],
      loading:false
    }
  },
  methods: {
    dialogClose() {
      this.addForm={}
       this.$emit('addClose')
    },
      clearForm(val) {
      if (val) {
        this.addForm = {}
      }
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true
        this.getchangeList(query, "")
      } else {
        this.options = []
      }
    },
    getchangeList(query) {
      this.$http
        .request({
          url: "/ypt/admin/all/customer/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 1000,
            customerName: query,
            isEquCustomer: 0,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content != null) {
              this.options = res.content.list
            } else {
              this.options = []
            }
            this.loading = false
          }
        })
    },
    async handleSelect(val) {
      this.options.forEach((item) => {
        if (item.id == val) {
          console.log(val,'val')
          this.addForm = JSON.parse(JSON.stringify(item))
          
        }
      })
    },
    locationSend(){
        this.$http
        .request({
          url: "/ypt/admin/all/customer/info/updateCustomerEquFlag",
          method: "post",
          data: {id:this.addForm.id},
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(`设置成功`)
              this.dialogClose()
          }
        })
    }
  },
  mounted() {
  }
}
</script>